/** @jsx jsx */

import { jsx } from '@emotion/core';
import { IconName } from '@zapier/zinnia-icons';
import { IconButton, Tooltip } from '@zapier/design-system';

type Props = {
  label: string;
  name: IconName;
  isDisabled?: boolean;
  onClick?: () => void;
};

const SidebarButton = (props: Props) => {
  const { isDisabled, label, name, onClick } = props;
  return (
    <Tooltip content={label}>
      <IconButton
        aria-label={label}
        isDisabled={isDisabled || onClick === undefined || onClick === null}
        name={name}
        onPress={onClick}
        size="small"
      />
    </Tooltip>
  );
};

export default SidebarButton;
